import React, { JSX, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import { signEula } from "authentication/AuthenticationService";
import { useAuth } from "authentication/AuthProvider";
import EulaDialog from "authentication/EulaDialog";

import { replaceWithFrom } from "utils/RouterUtils";
import LoginSection from "./login/LoginSection";
import OrganisationSection from "./login/OrganisationSection";
import LoginBanner from "./LoginBanner";

const LoginPage: React.FC = () => {
	const { principal, refreshTokens, removeTokens } = useAuth();

	const navigate = useNavigate();
	const location = useLocation();

	const [eulaDialog, setEulaDialog] = useState(false);
	const [section, setSection] = useState<JSX.Element>();

	useEffect(() => {
		if (!principal) {
			setSection(<LoginSection />);
			return;
		}

		if (!principal.signedEula) {
			setEulaDialog(true);
			return;
		}

		if (!principal.hasOrganisation()) {
			setSection(<OrganisationSection />);
			return;
		}

		if (principal.isFullyAuthenticated()) {
			replaceWithFrom(navigate, location);
		}
	}, [principal]);

	return (
		<Grid container direction="row" style={{ minHeight: "100vh" }}>
			<Grid
				item
				lg={7}
				xl={8}
				sx={{
					bgcolor: "primary.main",
					display: { xs: "none", lg: "block" }
				}}>
				<LoginBanner />
			</Grid>

			<Grid item xs={12} lg={5} xl={4} alignSelf="center">
				<Grid container justifyContent="center">
					<Grid item xs={10} sm={8} md={6} lg={10}>
						<Paper
							sx={{ padding: 2, margin: 2, textAlign: "center" }}>
							{section}
						</Paper>
					</Grid>
				</Grid>
			</Grid>

			{/* TODO: move to authenticated? */}
			{eulaDialog && (
				<EulaDialog
					onClose={() => {
						removeTokens();
						setEulaDialog(false);
					}}
					onAccept={() =>
						signEula()
							.then(() => setEulaDialog(false))
							.then(() =>
								refreshTokens(principal?.organisationId)
							)
					}
				/>
			)}
		</Grid>
	);
};

export default LoginPage;
